// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2XqFC"};